import { message } from "antd";
import  { useEffect } from "react";
const successMsg = ({msg, close}) => {

    useEffect(() => {
	showMsg();
    }, [msg]);

    const showMsg = () => {
	if (msg) {
	    if (close) {
		setTimeout(close, 4000);
	    }
	    message.success(msg);
	}
    };
    return null;
};


export default successMsg;
